import { createSelector } from "reselect";
import { getAllSureMotorClaim } from "./index";

export const getOtherDetails = createSelector(
    getAllSureMotorClaim,
    (allSureMotorClaim) => allSureMotorClaim.otherDetails
);
export const getOtherDetailsForm = createSelector(
    getOtherDetails,
    (otherDetails) => otherDetails.form
);


